"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const classnames_1 = __importDefault(require("classnames"));
const displayWrapper_1 = require("./common/displayWrapper");
const fieldWrapper_1 = require("./common/fieldWrapper");
const hooks_1 = require("./hooks");
const hooks_2 = require("common/hooks");
const ContractConfirmSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const { contractTitle, contractContent, issuerId, syncMode, email } = props.schema;
    const [locale] = (0, hooks_2.useContextLocale)();
    const { formatMessage, formatString } = (0, hooks_2.useFormatter)();
    const contract = (0, hooks_1.useContract)();
    const { contractConfirmed, setContractConfirmed, confirmedContractId } = (0, hooks_2.useContractConfirmed)({ contractTitle, contractContent, issuerId, email }, syncMode);
    const onChange = (e) => {
        const newValue = e.target.checked;
        setContractConfirmed(newValue);
    };
    const handleClickLink = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        const isApproved = yield contract({
            title: contractTitle,
            notice: formatMessage("PrivacyPolicy.Text"),
            message: contractContent,
            buttonLabelOK: formatMessage("Contract.OK"),
            buttonLabelCancel: formatMessage("Contract.Cancel"),
        });
        setContractConfirmed(isApproved);
    });
    const errorMessage = (0, react_1.useMemo)(() => {
        return (!contractConfirmed &&
            !value && {
            type: "needsPrivacyPolicy",
            message: formatMessage("validation/contract"),
        });
    }, [value, contractConfirmed, locale]);
    (0, react_1.useEffect)(() => {
        if (confirmedContractId !== value)
            registerProps.onChange(confirmedContractId);
    }, [confirmedContractId, value]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: { error: errorMessage || fieldState.error } },
        react_1.default.createElement(Form_1.default.Check, Object.assign({ type: "checkbox", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), style: { display: "inline-block" }, label: formatMessage("Contract.Approve"), checked: value || false }, registerProps, { onChange: onChange })),
        "\u00A0",
        react_1.default.createElement("a", { href: "#", onClick: handleClickLink }, formatMessage("Contract.Check"))));
};
ContractConfirmSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("ContractConfirmDisplayComponent");
exports.default = ContractConfirmSchemaComponent;
